<template>
	<v-tooltip bottom 
	v-if="userManagedDepts.length > 0 || useDevDatabase || userOccupantEditorDepts.length > 0 ? true : false">
		<v-btn slot="activator" 
			   icon large
			   :color = "!useDevDatabase ? '' : 'green lighten-3'" 
			   @click="toggleDB">
			<!-- {{ useDevDatabase ? "D" : "P" }} -->
			<v-icon :color="useDevDatabase ? 'black' : 'grey lighten-2'">
				{{useDevDatabase ? 'power_off' : 'power'}}
			</v-icon>
			<!-- <span class="title" :style="useDevDatabase ? 'color: black;' : 'color: lightgrey; opacity:0.5;'"> {{'</>'}} </span> -->
			<v-snackbar absolute v-model="snackbar" style="position: absolute; left:-400px; "
				top :timeout="3000">
		      	Now using {{useDevDatabase ? 'Development Database' : 'PRODUCTION Database'}}
		    </v-snackbar>
		</v-btn>
		<span>Toggle Database</span>
		
	</v-tooltip>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
name: 'DBToggleBtn',

data: () => ({
	
		snackbar: false,
		disabled: false,
	
}),

computed: {
	...mapState({   isSuperUser: state => state.user.isSuperUser,
					useDevDatabase: state => state.ui.useDevDatabase,
					userManagedDepts: state => state.user.userManagedDepts,
					userOccupantEditorDepts: state => state.user.userOccupantEditorDepts,
				}),
},

methods: {
	...mapMutations(['setUseDevDatabase', 'setSnackText', ]),
	...mapActions(['initializeData']),

	toggleDB: function () {
		this.setUseDevDatabase(!this.$store.state.ui.useDevDatabase)
		//this.setSnackText('Now Using: ' + `${this.useDevDatabase ? 'Development Database' : 'PRODUCTION Database'}`)
	    this.initializeData('refresh')
	    this.snackbar = true
	},



}
}
</script>



// WEBPACK FOOTER //
// src/components/DBToggleBtn.vue